// extracted by mini-css-extract-plugin
export default {"loader":"WithdrawFormContainer_loader__ip8qJ","container":"WithdrawFormContainer_container__2Zvb-"};